export const CONSTANTS = {
  CLIENT: 'client',
  CONTACT: 'contact',
  CONTACT_FINANCE: 'finance',
  CONTACT_FINANCE_EMAIL: 'email',
  CONTACT_FINANCE_FAX: 'fax',
  CONTACT_FINANCE_PHONE: 'phone',
  CONTACT_ORDERPROCESS: 'orderprocess',
  CONTACT_ORDERPROCESS_EMAIL: 'email',
  CONTACT_SALES: 'sales',
  CONTACT_SALES_EMAIL: 'email',
  CONTACT_SALES_FAX: 'fax',
  CONTACT_SALES_PHONE: 'phone',
  CONTACT_SERVICE: 'service',
  CONTACT_SERVICE_EMAIL: 'email',
  CONTACT_SERVICE_FAX: 'fax',
  CONTACT_SERVICE_PHONE: 'phone',
  COUNTRY_ISO: 'country_iso',
  CURRENCY: 'currency',
  DESCRIPTION: 'description',
  INFORMATION: 'information',
  INFORMATION_FREIGHT: 'freight',
  INFORMATION_PAYMENT_CONDITION_LONG: 'payment_condition_long',
  INFORMATION_PAYMENT_CONDITION_SHORT: 'payment_condition_short',
  OPCO_NO: 'opco_no',
  ALL_CLIENTS: 'ALL_CLIENTS',
}

const PATHS = {
  CLIENT: [CONSTANTS.CLIENT],
  CONTACT: [CONSTANTS.CONTACT],
  CONTACT_FINANCE: [CONSTANTS.CONTACT, CONSTANTS.CONTACT_FINANCE],
  CONTACT_FINANCE_EMAIL: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_FINANCE,
    CONSTANTS.CONTACT_FINANCE_EMAIL,
  ],
  CONTACT_FINANCE_FAX: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_FINANCE,
    CONSTANTS.CONTACT_FINANCE_FAX,
  ],
  CONTACT_FINANCE_PHONE: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_FINANCE,
    CONSTANTS.CONTACT_FINANCE_PHONE,
  ],
  CONTACT_ORDERPROCESS: [CONSTANTS.CONTACT, CONSTANTS.CONTACT_ORDERPROCESS],
  CONTACT_ORDERPROCESS_EMAIL: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_ORDERPROCESS,
    CONSTANTS.CONTACT_ORDERPROCESS_EMAIL,
  ],
  CONTACT_SALES: [CONSTANTS.CONTACT, CONSTANTS.CONTACT_SALES],
  CONTACT_SALES_EMAIL: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_SALES_EMAIL,
    CONSTANTS.CONTACT_SALES_EMAIL,
  ],
  CONTACT_SALES_FAX: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_SALES_EMAIL,
    CONSTANTS.CONTACT_SALES_FAX,
  ],
  CONTACT_SALES_PHONE: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_SALES_EMAIL,
    CONSTANTS.CONTACT_SALES_PHONE,
  ],
  CONTACT_SERVICE: [CONSTANTS.CONTACT, CONSTANTS.CONTACT_SERVICE],
  CONTACT_SERVICE_EMAIL: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_SERVICE,
    CONSTANTS.CONTACT_SERVICE_EMAIL,
  ],
  CONTACT_SERVICE_FAX: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_SERVICE,
    CONSTANTS.CONTACT_SERVICE_FAX,
  ],
  CONTACT_SERVICE_PHONE: [
    CONSTANTS.CONTACT,
    CONSTANTS.CONTACT_SERVICE,
    CONSTANTS.CONTACT_SERVICE_PHONE,
  ],
  COUNTRY_ISO: [CONSTANTS.COUNTRY_ISO],
  CURRENCY: [CONSTANTS.CURRENCY],
  DESCRIPTION: [CONSTANTS.DESCRIPTION],
  INFORMATION: [CONSTANTS.INFORMATION],
  INFORMATION_FREIGHT: [CONSTANTS.INFORMATION, CONSTANTS.INFORMATION_FREIGHT],
  INFORMATION_PAYMENT_CONDITION_LONG: [
    CONSTANTS.INFORMATION,
    CONSTANTS.INFORMATION_PAYMENT_CONDITION_LONG,
  ],
  INFORMATION_PAYMENT_CONDITION_SHORT: [
    CONSTANTS.INFORMATION,
    CONSTANTS.INFORMATION_PAYMENT_CONDITION_SHORT,
  ],
  OPCO_NO: [CONSTANTS.OPCO_NO],
}
export default {
  ...CONSTANTS,
  PATHS,
}
